var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 69.453 78.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16706",
    "data-name": "Group 16706",
    transform: "translate(-302.766 -968.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16707",
    "data-name": "Group 16707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32333",
    "data-name": "Path 32333",
    d: "M68.217,33.156H89.25A6.969,6.969,0,0,1,94.178,35.2l14.7,14.7a6.97,6.97,0,0,1,2.041,4.929v7.137l-4.643-2.814v-3.93H95.819a6.969,6.969,0,0,1-6.969-6.969V37.8H70.54Zm30.654,65.05,2.321,4.644H64.458a6.969,6.969,0,0,1-6.969-6.969V74.043l4.648,2.811v19.03a2.323,2.323,0,0,0,2.323,2.323M93.5,41.087v7.17A2.323,2.323,0,0,0,95.82,50.58h7.169Z",
    transform: "translate(253.202 940.415)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8725",
    "data-name": "Rectangle 8725",
    width: 69.452,
    height: 78.803,
    transform: "translate(302.766 969)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_32334",
    "data-name": "Path 32334",
    d: "M48.346,69.5l-.765-1.531a13.869,13.869,0,0,1-1.28-5.422v-8.09a6.949,6.949,0,0,1,8.3-6.82l-4.544-7.791a6.967,6.967,0,0,1,1.871-9.089,9.554,9.554,0,0,1,.825-.507,6.778,6.778,0,0,1,3.867-.677.763.763,0,0,1,.2.053,20.11,20.11,0,0,1,4.157,2.472,2.564,2.564,0,0,1,.642.7l0,0L67.91,43.157a12.036,12.036,0,0,1,1.542,5.5V76.439a2.315,2.315,0,1,1-4.63.1c0-.032,0-.064,0-.1V48.657a7.583,7.583,0,0,0-.87-3.1L57.66,35.2a2.172,2.172,0,0,0-2.912-.773,2.335,2.335,0,0,0-.7,3.08l4.663,7.99a12.3,12.3,0,0,1,1.476,5.469v9.262a2.315,2.315,0,0,1-4.629.1c0-.032,0-.064,0-.1V54.5A2.365,2.365,0,0,0,53.2,52.125a2.315,2.315,0,0,0-2.271,2.315v8.1a9.421,9.421,0,0,0,.79,3.352L56.471,75.4a2.315,2.315,0,0,1-4.141,2.07l-1.67-3.341ZM21.112,9.307l.763,1.525a13.871,13.871,0,0,1,1.28,5.422v8.09a6.949,6.949,0,0,1-8.3,6.821L19.4,38.956a6.966,6.966,0,0,1-1.871,9.089,9.556,9.556,0,0,1-.825.507,7.207,7.207,0,0,1-4.1.666,25.354,25.354,0,0,1-4.656-2.8c-3.107-4.844-.031-.278-6.41-10.776A12.036,12.036,0,0,1,0,30.146V2.362a2.315,2.315,0,1,1,4.629-.1c0,.032,0,.064,0,.1V30.145a7.584,7.584,0,0,0,.87,3.1L11.793,43.6a2.172,2.172,0,0,0,2.913.774,2.335,2.335,0,0,0,.7-3.081L10.741,33.3a12.3,12.3,0,0,1-1.476-5.469V18.566a2.315,2.315,0,0,1,4.629-.1c0,.032,0,.064,0,.1v5.787a2.315,2.315,0,0,0,4.63.088q0-.048,0-.1v-8.09a9.417,9.417,0,0,0-.79-3.352L12.981,3.4a2.315,2.315,0,0,1,4-2.324,2.435,2.435,0,0,1,.141.253L18.8,4.677Z",
    transform: "translate(302.766 969)",
    fill: "#96006b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamDocuments);
export default __webpack_public_path__ + "static/media/TeamDocuments.b3baa23e96950a39c89106f0dc427406.svg";
export { ForwardRef as ReactComponent };